<template>
  <div class="min-h-screen flex flex-col">
    <TopBar />
    <main class="pt-6 pb-6 flex-grow bg-gray-100">
      <div class="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div class="sm:max-w-full md:max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto">

          <router-view />

        </div>
      </div>
    </main>
    <footer class="bg-gray-200 py-4">
      <p class="text-center">© 2024 EasyMarks AI</p>
    </footer>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'

export default {
  components: {
    TopBar
  }
}
</script>
